import React from 'react'

export default function Button(props) {
  const {children, className, variant, ...rest} = props

  const conditionalClasses = [
    variant === 'round' && 'rounded-full px-3',
    variant !== 'round' && 'px-6',
    className,
  ].filter(Boolean)

  const cn = `inline-flex justify-center items-center py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:bg-blue-500 disabled:cursor-not-allowed disabled:opacity-50 ${conditionalClasses.join(' ')}`

  return <button
    type="button"
    className={cn}
    {...rest}
  >
    { children }
  </button>
}
